import { useTranslation } from "react-i18next";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { ListItem } from "@mui/material";

import { FileListItem } from "../../../../../../file-list-item/FileListItem";
import { formatDateTime } from "../../../../../../format/formatDate";
import { BankStatementResponse } from "../../../../../api/ClientFileApi";
import { useClientFileContext } from "../../../../../context/ClientFileContext";

const SECTION = "clients.client.debtSettlement.assetInventory.section1.bankStatement";

interface Props {
  statement: BankStatementResponse;
  onMarkRead: (documentId: string, isRead: boolean) => void;
  onDelete?: (documentId: string, fileName: string) => void;
  isBusy: boolean;
}

export function BankStatementRow({ statement, onMarkRead, onDelete, isBusy }: Props) {
  const { t } = useTranslation();
  // The mark-read endpoint is staff-only; without the capability the row renders without the toggle.
  const { capabilities } = useClientFileContext();

  return (
    <ListItem disableGutters>
      <FileListItem
        fileName={statement.fileName}
        contentType={statement.contentType}
        sizeBytes={statement.fileSizeBytes}
        secondaryText={formatDateTime(statement.createdAtUtc, "Pp")}
        menuAriaLabel={t(`${SECTION}.fileActions`, { fileName: statement.fileName })}
        isBusy={isBusy}
        onDelete={onDelete ? () => onDelete(statement.documentId, statement.fileName) : undefined}
        menuItems={
          capabilities.markBankStatementsRead
            ? [
                {
                  key: "toggle-read",
                  label: t(statement.isRead ? `${SECTION}.markAsUnread` : `${SECTION}.markAsRead`),
                  icon: statement.isRead ? <RadioButtonUncheckedIcon /> : <CheckCircleOutlineIcon />,
                  onClick: () => onMarkRead(statement.documentId, !statement.isRead),
                },
              ]
            : []
        }
      />
    </ListItem>
  );
}
